import { DatePipe } from '@angular/common';
import {
  Component,
  OnInit
} from '@angular/core';
import {
  ModalController,
  NavParams,
  Events
} from '@ionic/angular';
import { Observable } from 'rxjs/Observable';
import { CommonUtilitiesService } from '@shared/service/common-utilities.service';

@Component({
  selector: 'app-sharedcommentbox',
  templateUrl: './sharedcommentbox.component.html',
  styleUrls: ['./sharedcommentbox.component.scss'],
})
export class SharedcommentboxComponent implements OnInit {
  results: Observable<any[]>;
  showParkDate: boolean = false;
  showComments: boolean = false;
  showMgrEmail: boolean = false;

  CommentsTxt: any = '';
  selectedMgrId: any = '';
  selParkDate: any = '';
  buttonClckGetID: any = 0;
  reqID: any = 0;
  orgID: any = 0;

  constructor(
    public modalController: ModalController,
    public navParams: NavParams,
    public events: Events,
    private datepipe: DatePipe,
    public commonUtils: CommonUtilitiesService) {
  }

  ngOnInit() {
    this.buttonClckGetID = this.navParams.get("id");
    this.results = this.navParams.get('list');
    if (this.buttonClckGetID === 2 || this.buttonClckGetID == 3) {
      this.showComments = true;
    } else if (this.buttonClckGetID === 6 || this.buttonClckGetID === 9) {
      this.showParkDate = true;
      this.showComments = true;
    } else if (this.buttonClckGetID === 4) {
      this.loadManagersList();
      this.showMgrEmail = true;
      this.showComments = true;
    }
  }

  addCommentsClick() {
    console.log("addCommentsClick : " +  this.buttonClckGetID);

    if (this.buttonClckGetID === 2) {
      if (this.CommentsTxt.length === 0) {
        this.commonUtils.presentToastWithOptions(false, "Please provide Comments", "");
      } else {
        this.events.publish('functionCall:fromCommentsPage', { id: this.buttonClckGetID, comments: this.CommentsTxt, parkDate: this.selParkDate, mrgEmailID: this.selectedMgrId });
        this.dismiss();
      }
    } else if (this.buttonClckGetID === 3) {
      if (this.CommentsTxt.length === 0) {
        this.commonUtils.presentToastWithOptions(false, "Please provide Comments", "");
      } else {
        this.events.publish('functionCall:fromCommentsPage', { id: this.buttonClckGetID, comments: this.CommentsTxt, parkDate: this.selParkDate, mrgEmailID: this.selectedMgrId });
        this.dismiss();
      }
    } else if (this.buttonClckGetID === 6) {
      if (this.selParkDate.length == 0) {
        this.commonUtils.presentToastWithOptions(false, "Please select date", "");
      } else if (this.CommentsTxt.length === 0) {
        this.commonUtils.presentToastWithOptions(false, "Please provide Comments", "");
      } else {
        this.events.publish('functionCall:fromCommentsPage', { id: this.buttonClckGetID, comments: this.CommentsTxt, parkDate: this.datepipe.transform(this.selParkDate, 'MM/dd/yyyy'), mrgEmailID: this.selectedMgrId });
        this.dismiss();
      }
    } else if (this.buttonClckGetID === 9) {
      if (this.selParkDate.length == 0) {
        this.commonUtils.presentToastWithOptions(false, "Please select date", "");
      } else if (this.CommentsTxt.length === 0) {
        this.commonUtils.presentToastWithOptions(false, "Please provide Comments", "");
      } else {
        this.events.publish('functionCall:forApprovalPageComments', { id: 6, comments: this.CommentsTxt, parkDate: this.datepipe.transform(this.selParkDate, 'MM/dd/yyyy'), mrgEmailID: this.selectedMgrId });
        this.dismiss();
      }
    } else if (this.buttonClckGetID === 4) {
      if (this.selectedMgrId.length === 0) {
        this.commonUtils.presentToastWithOptions(false, "Please select Manager Email", "");
      } else if (this.CommentsTxt.length == 0) {
        this.commonUtils.presentToastWithOptions(false, "Please provide Comments", "");
      } else {
        this.events.publish('functionCall:fromCommentsPage', { id: this.buttonClckGetID, comments: this.CommentsTxt, parkDate: this.selParkDate, mrgEmailID: this.selectedMgrId });
        this.dismiss();
      }
    }

  }

  loadManagersList() {
    let methodName = 'getManagers';
    // this.loadData(methodName, this.prepareBodyForRequest(methodName))
    //   .then(data => {
    //     try {
    //       if (data.length > 0) {
    //         var cnt = 0, output = [];
    //         this.managerList = [];
    //         this.finalEmialList = [];
    //         this.managerList = data;

    //         for (var i = 0; i < this.managerList.length; i++) {
    //           if (parseFloat(this.managerList[i].approvalLimit) > parseFloat(this.globalVars.totalExpAmt) && (!((this.globalVars.userEmail.indexOf(this.managerList[i].email.split(' -- ')[0])) >= 0))) {
    //             this.finalEmialList.push(this.managerList[i]);
    //           }
    //         }
    //       } else {
    //         this.errorTxt = data;
    //         //this.approveItService.onError(data, methodName);
    //       }
    //     } catch (e) {
    //       //this.approveItService.onException(e, methodName);
    //     }
    //   });
  }

  prepareBodyForRequest(methodName) {
    if (methodName == 'getManagers') {
      return JSON.stringify({
        "param1": "",
        "param2": "",
        "param3": "",
        "param4": 2,
        "param5": "",
        "param6": "",
        "param7": null,
        "param8": "",
        "param9": "",
        "param10": ""
      });
    }
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      'dismissed': true
    });
  }

}
